import React from "react";
import clsx from "clsx";

import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { transformViewDate } from "utils/date-utils";
import VideoDetails from "../VideoDetails";
import { DATE_TIME_FORMAT, EVideoListTab } from "../../helpers";
import useStyles from "./styles";

interface IProps {
  onClose: () => void;
  selectedVideo: racehorse360.ITrackOpticsVideo;
  activeTab: EVideoListTab;
  onUpdateVideoList: () => void;
  className?: string;
}

const MobileViewVideoDetails = (props: IProps) => {
  const { onClose, selectedVideo, ...restProps } = props;

  const classes = useStyles();

  return (
    <Dialog open={true} fullScreen={true} onClose={onClose}>
      <DialogTitle className={classes.dialogHeader}>
        <IconButton onClick={onClose} className={classes.closeButton}>
          <CloseIcon className={classes.closeButtonIcon} />
        </IconButton>
        <div className={clsx(classes.dialogHeaderItem, classes.dialogTitle)}>
          TrackOptics Workout
        </div>
        <div
          className={clsx(classes.dialogHeaderItem, classes.dialogHeaderInfo)}
        >
          {`${selectedVideo.facility.name.toLowerCase()} - `}
          {transformViewDate(selectedVideo.date, null, DATE_TIME_FORMAT)}
        </div>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <VideoDetails
          className={classes.mobileVideoDetailsContent}
          selectedVideo={selectedVideo}
          {...restProps}
        />
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(MobileViewVideoDetails);
